import React, { useRef } from 'react'
import useHover from 'hooks/useHover'
import Icon from 'components/Icon'
import './_index.scss'

interface AttributeProps {
  iconKey?: string
  iconUrl?: string
  name: string
}

const Attribute: React.FC<AttributeProps> = ({ name, iconKey, iconUrl }) => {
  const hoverRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const { isHover, onHover } = useHover(containerRef, { addMovingHover: true, hoverRef })

  return (
    <div
      ref={containerRef}
      onMouseEnter={onHover}
      className='mag__attribute'>
      {isHover && <span ref={hoverRef} className='mag__attribute__hover'>{name}</span>}
      {(iconKey || iconUrl) && <div className='mag__attribute__icon'>
        {iconKey
          ? <i className={`icon icon--${iconKey}`} />
          : <Icon
            size='20px'
            icon={iconUrl!}
          />}
      </div>}
      <span>{name}</span>
    </div>
  )
}

export default Attribute